import React from 'react';
import PropTypes from 'prop-types';

import { FormHeading } from './FormHeading';
import { FormHelperText } from './FormHelperText';

const defaultHelperText = <></>;

export function FormFields({ isLoading = false, headingText = "", helperText = defaultHelperText, dangerHelperText = "", children }) {
    return (
        <div className="form-field">
            <FormHeading loading={isLoading} headingLevel={"h4"}>{headingText}</FormHeading>
            <FormHelperText loading={isLoading}>{helperText}</FormHelperText>
            {children}
            <FormHelperText loading={isLoading} danger>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormFields.propTypes = {
    isLoading: PropTypes.bool,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    dangerHelperText: PropTypes.string,
    children: PropTypes.node
}
